// extracted by mini-css-extract-plugin
export var active = "_a3-7";
export var blink = "_a3-8";
export var dropDownSelector = "_a3-4";
export var dropDownWrapper = "_a3-3";
export var fakeCursor = "_a3-6";
export var fontSizeButton = "_a3-9";
export var formQuillEditor = "_a3-0";
export var pressed = "_a3-a";
export var qlBlank = "_a3-1";
export var textFormattingToolbar = "_a3-2";
export var textToolbarOption = "_a3-5";